const setWidth = () => {
    APP.websiteWrapper.css({
        'max-width' : window.deviceWidth + 'px'
    });
}
const unsetWidth = () => {
    APP.websiteWrapper.removeAttr('style');
}
